/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';
import {
  clearKwVolumeAmazonCategoryTreeFromLevel,
  createEmptyKwVolumeAmazonCategoryTree,
  mapKwVolumePickerRootsToCategory1
} from 'feactures/categoryKeywordVolume/kwVolumePickerUtils';

export const fetchCategoryKeywordVolumeCategories = createAsyncThunk(
  'categoryKeywordVolume/fetchCategories',
  async ({ account_id, premium }, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/categories`,
      { account_id, premium: Boolean(premium) }
    );
    return res.data;
  }
);

export const fetchKwVolumePickerOptions = createAsyncThunk(
  'categoryKeywordVolume/fetchPickerOptions',
  async ({ marketplace, account_id } = {}, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/picker_options`,
      {
        marketplace: marketplace || 'JP',
        account_id
      }
    );
    return res.data;
  }
);

export const fetchKwVolumeScMasterChildren = createAsyncThunk(
  'categoryKeywordVolume/fetchScMasterChildren',
  async ({ parent_id, level, marketplace } = {}, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/picker_children`,
      {
        parent_id,
        marketplace: marketplace || 'JP'
      }
    );
    return {
      ...res.data,
      level,
      parent_id
    };
  }
);

export const registerCategoryKeywordVolumeCategory = createAsyncThunk(
  'categoryKeywordVolume/registerCategory',
  async ({ account_id, category_id, category_name, premium }, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/categories/register`,
      {
        account_id,
        category_id,
        category_name,
        premium: Boolean(premium)
      }
    );
    return res.data;
  }
);

export const deleteCategoryKeywordVolumeCategory = createAsyncThunk(
  'categoryKeywordVolume/deleteCategory',
  async ({ account_id, category_id, premium }, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/categories/delete`,
      {
        account_id,
        category_id,
        premium: Boolean(premium)
      }
    );
    return res.data;
  }
);

export const fetchCategoryKeywordVolumeReports = createAsyncThunk(
  'categoryKeywordVolume/fetchReports',
  async ({ account_id, category_id, start, end }, thunkAPI) => {
    const res = await client.post(`${apiUrl}category_keyword_volume/reports`, {
      account_id,
      category_id,
      start,
      end
    });
    return res.data;
  }
);

export const fetchKwVolumeDashboardSummary = createAsyncThunk(
  'categoryKeywordVolume/fetchDashboardSummary',
  async ({ account_id, premium }, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/dashboard_summary`,
      { account_id, premium: Boolean(premium) }
    );
    return res.data;
  }
);

export const requestKwVolumeCategoryData = createAsyncThunk(
  'categoryKeywordVolume/requestCategoryData',
  async ({ volume_category_id }, thunkAPI) => {
    const res = await client.post(
      `${apiUrl}category_keyword_volume/categories/request_data`,
      { volume_category_id }
    );
    return res.data;
  }
);

const slice = createSlice({
  name: 'categoryKeywordVolume',
  initialState: {
    categories: [],
    categoriesStatus: 'idle',
    reportsByCategoryId: {},
    reportsStatus: 'idle',
    kwVolumePickerOptions: null,
    kwVolumePickerOptionsStatus: 'idle',
    kwVolAmazonCategoryTree: createEmptyKwVolumeAmazonCategoryTree(),
    kwVolScMasterChildrenStatus: 'idle',
    kwVolumeDashboardSummary: null,
    kwVolumeDashboardSummaryStatus: 'idle',
    /** KW 検索ボリューム登録モーダル専用（市場ビューの categoryGraph と独立） */
    kwVolAmazon_cate1: 0,
    kwVolAmazon_cate2: 0,
    kwVolAmazon_cate3: 0,
    kwVolAmazon_cate4: 0,
    kwVolAmazon_cate5: 0,
    kwVolAmazon_cate6: 0
  },
  reducers: {
    kwVolChangeAcate1(state, action) {
      state.kwVolAmazon_cate1 = action.payload;
      state.kwVolAmazon_cate2 = 0;
      state.kwVolAmazon_cate3 = 0;
      state.kwVolAmazon_cate4 = 0;
      state.kwVolAmazon_cate5 = 0;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        2
      );
    },
    kwVolChangeAcate2(state, action) {
      state.kwVolAmazon_cate2 = action.payload;
      state.kwVolAmazon_cate3 = 0;
      state.kwVolAmazon_cate4 = 0;
      state.kwVolAmazon_cate5 = 0;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        3
      );
    },
    kwVolChangeAcate3(state, action) {
      state.kwVolAmazon_cate3 = action.payload;
      state.kwVolAmazon_cate4 = 0;
      state.kwVolAmazon_cate5 = 0;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        4
      );
    },
    kwVolChangeAcate4(state, action) {
      state.kwVolAmazon_cate4 = action.payload;
      state.kwVolAmazon_cate5 = 0;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        5
      );
    },
    kwVolChangeAcate5(state, action) {
      state.kwVolAmazon_cate5 = action.payload;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        6
      );
    },
    kwVolChangeAcate6(state, action) {
      state.kwVolAmazon_cate6 = action.payload;
    },
    resetKwVolAmazonPicker(state) {
      state.kwVolAmazon_cate1 = 0;
      state.kwVolAmazon_cate2 = 0;
      state.kwVolAmazon_cate3 = 0;
      state.kwVolAmazon_cate4 = 0;
      state.kwVolAmazon_cate5 = 0;
      state.kwVolAmazon_cate6 = 0;
      state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
        state.kwVolAmazonCategoryTree,
        2
      );
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryKeywordVolumeCategories.pending, (state) => {
        state.categoriesStatus = 'loading';
      })
      .addCase(fetchCategoryKeywordVolumeCategories.fulfilled, (state, action) => {
        state.categoriesStatus = 'succeeded';
        state.categories = action.payload?.categories || [];
      })
      .addCase(fetchCategoryKeywordVolumeCategories.rejected, (state) => {
        state.categoriesStatus = 'failed';
      })
      .addCase(fetchKwVolumePickerOptions.pending, (state) => {
        state.kwVolumePickerOptionsStatus = 'loading';
        state.kwVolScMasterChildrenStatus = 'idle';
        state.kwVolAmazonCategoryTree = createEmptyKwVolumeAmazonCategoryTree();
      })
      .addCase(fetchKwVolumePickerOptions.fulfilled, (state, action) => {
        state.kwVolumePickerOptionsStatus = 'succeeded';
        state.kwVolumePickerOptions = action.payload || null;
        const po = state.kwVolumePickerOptions;
        if (po && !po.master_unavailable) {
          state.kwVolAmazonCategoryTree = {
            ...createEmptyKwVolumeAmazonCategoryTree(),
            category1: mapKwVolumePickerRootsToCategory1(po.roots)
          };
        } else {
          state.kwVolAmazonCategoryTree = createEmptyKwVolumeAmazonCategoryTree();
        }
      })
      .addCase(fetchKwVolumePickerOptions.rejected, (state) => {
        state.kwVolumePickerOptionsStatus = 'failed';
        state.kwVolumePickerOptions = null;
        state.kwVolAmazonCategoryTree = createEmptyKwVolumeAmazonCategoryTree();
      })
      .addCase(fetchKwVolumeScMasterChildren.pending, (state) => {
        state.kwVolScMasterChildrenStatus = 'loading';
      })
      .addCase(fetchKwVolumeScMasterChildren.fulfilled, (state, action) => {
        state.kwVolScMasterChildrenStatus = 'succeeded';
        const level = Number(action.payload?.level);
        if (!Number.isFinite(level) || level < 2 || level > 6) {
          return;
        }
        const children = Array.isArray(action.payload?.children)
          ? action.payload.children
          : [];
        const nextTree = {
          ...state.kwVolAmazonCategoryTree,
          [`category${level}`]: children
        };
        state.kwVolAmazonCategoryTree = clearKwVolumeAmazonCategoryTreeFromLevel(
          nextTree,
          level + 1
        );
      })
      .addCase(fetchKwVolumeScMasterChildren.rejected, (state) => {
        state.kwVolScMasterChildrenStatus = 'failed';
      })
      .addCase(registerCategoryKeywordVolumeCategory.fulfilled, (state) => {
        // 登録後の反映は呼び出し側で再取得する
      })
      .addCase(deleteCategoryKeywordVolumeCategory.fulfilled, (state) => {
        // 削除後の反映は呼び出し側で再取得する
      })
      .addCase(fetchCategoryKeywordVolumeReports.pending, (state) => {
        state.reportsStatus = 'loading';
      })
      .addCase(fetchCategoryKeywordVolumeReports.fulfilled, (state, action) => {
        state.reportsStatus = 'succeeded';
        const reports = action.payload?.reports || [];
        // category_id をpayloadに含めてないので、呼び出し側でcategoryIdを渡して set する設計にしたいが、
        // 既存の使い方に寄せて、最後に取得したものを lastReports として扱う
        state.lastReports = reports;
      })
      .addCase(fetchCategoryKeywordVolumeReports.rejected, (state) => {
        state.reportsStatus = 'failed';
      })
      .addCase(fetchKwVolumeDashboardSummary.pending, (state) => {
        state.kwVolumeDashboardSummaryStatus = 'loading';
      })
      .addCase(fetchKwVolumeDashboardSummary.fulfilled, (state, action) => {
        state.kwVolumeDashboardSummaryStatus = 'succeeded';
        state.kwVolumeDashboardSummary = action.payload || null;
      })
      .addCase(fetchKwVolumeDashboardSummary.rejected, (state) => {
        state.kwVolumeDashboardSummaryStatus = 'failed';
        state.kwVolumeDashboardSummary = null;
      });
  }
});

export const categoryKeywordVolumeCategoriesSelector = (state) =>
  state.categoryKeywordVolume.categories;
export const categoryKeywordVolumeCategoriesStatusSelector = (state) =>
  state.categoryKeywordVolume.categoriesStatus;
export const categoryKeywordVolumeLastReportsSelector = (state) =>
  state.categoryKeywordVolume.lastReports || [];
export const categoryKeywordVolumeReportsStatusSelector = (state) =>
  state.categoryKeywordVolume.reportsStatus;

export const kwVolumePickerOptionsSelector = (state) =>
  state.categoryKeywordVolume.kwVolumePickerOptions;

export const kwVolumePickerOptionsStatusSelector = (state) =>
  state.categoryKeywordVolume.kwVolumePickerOptionsStatus || 'idle';

export const kwVolAmazonCategoryTreeSelector = (state) =>
  state.categoryKeywordVolume.kwVolAmazonCategoryTree ||
  createEmptyKwVolumeAmazonCategoryTree();

export const kwVolScMasterChildrenStatusSelector = (state) =>
  state.categoryKeywordVolume.kwVolScMasterChildrenStatus || 'idle';

export const kwVolumeDashboardSummarySelector = (state) =>
  state.categoryKeywordVolume.kwVolumeDashboardSummary;

export const kwVolumeDashboardSummaryStatusSelector = (state) =>
  state.categoryKeywordVolume.kwVolumeDashboardSummaryStatus || 'idle';

export const currentKwVolumeAmazonCategoryList = (state) => [
  state.categoryKeywordVolume.kwVolAmazon_cate1,
  state.categoryKeywordVolume.kwVolAmazon_cate2,
  state.categoryKeywordVolume.kwVolAmazon_cate3,
  state.categoryKeywordVolume.kwVolAmazon_cate4,
  state.categoryKeywordVolume.kwVolAmazon_cate5,
  state.categoryKeywordVolume.kwVolAmazon_cate6
];

export const currentKwVolumeAmazonCate1 = (state) =>
  state.categoryKeywordVolume.kwVolAmazon_cate1;

export const {
  kwVolChangeAcate1,
  kwVolChangeAcate2,
  kwVolChangeAcate3,
  kwVolChangeAcate4,
  kwVolChangeAcate5,
  kwVolChangeAcate6,
  resetKwVolAmazonPicker
} = slice.actions;

export default slice.reducer;

